var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.ehPerfilFornecedor)?_c('iframe',{staticClass:"manual-box",attrs:{"id":"box-fornecedor","title":"manual","src":"https://manualize.com.br/categoria_compra_direta/fornecedor-compra-sem-disputa"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }